import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { fullParagraphRevealAnimation } from './animations'
import { Section, WPLink } from '@/types'

type FullParagraphProps = Section &
  Partial<{
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    paragraph: string
    button: WPLink
  }>

const FullParagraph = ({
  title,
  title_variant,
  title_component,
  paragraph,
  button,
  ...props
}: FullParagraphProps) => {
  return (
    <Motion animation={fullParagraphRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid>
              <div className="col-span-2 md:col-span-6 lg:col-span-12">
                <div className="grid gap-lg">
                  {title ? (
                    <Typography
                      variant={title_variant}
                      component={title_component}
                      className="uppercase text-white [&_em]:text-blue-soft"
                      data-motion-title
                    >
                      {title}
                    </Typography>
                  ) : null}

                  {paragraph ? (
                    <Typography
                      variant="body"
                      paragraph
                      className="text-white/80"
                      data-motion-paragraph
                    >
                      {paragraph}
                    </Typography>
                  ) : null}

                  {button ? (
                    <div data-motion-button>
                      <Button href={button?.url} link variant="contained">
                        {button?.title}
                      </Button>
                    </div>
                  ) : null}
                </div>
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default FullParagraph
